import Model from 'flarum/common/Model';

export default class CourseCompletion extends Model {}

Object.assign(CourseCompletion.prototype, {
  userId: Model.attribute('user_id'),
  articleId: Model.attribute('article_id'),
  courseId: Model.attribute('course_id'),
  assignmentPassed: Model.attribute('assignment_passed'),
  quizPassed: Model.attribute('quiz_passed'),
  rewardGranted: Model.attribute('reward_granted'),
  completedAt: Model.attribute('completed_at', Model.transformDate),
});
